import React, { SVGProps } from 'react'

const SvgHeroArrowTopRightOnSquare = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg viewBox='0 0 24 24' className='svg-icon' {...props}>
            <path
                d='M11.5 4H3.25C2.65326 4 2.08097 4.23705 1.65901 4.65901C1.23705 5.08097 1 5.65326 1 6.25V16.75C1 17.3467 1.23705 17.919 1.65901 18.341C2.08097 18.7629 2.65326 19 3.25 19H13.75C14.3467 19 14.919 18.7629 15.341 18.341C15.7629 17.919 16 17.3467 16 16.75V8.5M5.5 14.5L19 1M19 1H13.75M19 1V6.25'
                stroke='#E4E4E7'
                stroke-width='1.88'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
        </svg>
    )
}

export default SvgHeroArrowTopRightOnSquare
